export const BACKLOG_REASONS = [
    'UTR Shortage',
    'Line Haul Delays',
    'Outbound Line Haul Shortage',
    'Low SPR (D-1 vs Act)',
    'DSP Absence',
    'AmFlex Cancel',
    'Low Flex Increment',
    'RME Issue',
    'Natural Disaster',
    'High RTS - Weather',
    'High RTS - Business Closed',
    'High RTS - Not Attempt',
    'High RTS - Others',
    'High Schedule',
    'Other',
];